import { render, staticRenderFns } from "./ListLoading.vue?vue&type=template&id=1511847d&scoped=true&"
import script from "./ListLoading.vue?vue&type=script&lang=js&"
export * from "./ListLoading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1511847d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VLazy } from 'vuetify/lib/components/VLazy';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VLazy,VProgressCircular})
